import { APP_ROUTES } from "enums/APP_ROUTES";
import useProject from "../useProject";
import useVidletNavigate from "./useVidletNavigate";

export default function useNavigateTo() {
  const { projectPaths } = useProject();

  const { navigate } = useVidletNavigate();

  function navigateTo(route: APP_ROUTES, path?: string, ...rest) {
    navigate(`${projectPaths[route]}${path || ""}`, ...rest);
  }

  return navigateTo;
}
